import { tokenFingerprint } from './operandiCaptureQueue';

const STORAGE_PREFIX = 'workforce-exchange-pending-v1:';
let sessionRevision = 0;

async function storageKey(scope) {
  const revision = sessionRevision;
  const fingerprint = await tokenFingerprint(scope?.token);
  if (revision !== sessionRevision) throw new Error('Workforce request session ended');
  if (!fingerprint || !scope?.orgId || !scope?.locationId) throw new Error('Secure request retry storage unavailable');
  return `${STORAGE_PREFIX}${JSON.stringify([scope.orgId, scope.locationId, fingerprint])}`;
}
function valid(saved, scope) {
  const body = saved?.body;
  const fields = ['command_id', 'location_id', 'from_employee_id', 'to_employee_id',
    ...(saved?.kind === 'swap' ? ['from_shift_id', 'to_shift_id'] : ['shift_id'])];
  return ['swap', 'offer'].includes(saved?.kind) && body && body.location_id === scope.locationId
    && Object.keys(body).length === fields.length
    && fields.every(field => typeof body[field] === 'string' && body[field].length > 0)
    && /^[A-Za-z0-9_.:-]{1,128}$/.test(body.command_id);
}
export async function loadExchangeRetry(scope) {
  const revision = sessionRevision, key = await storageKey(scope);
  if (revision !== sessionRevision) throw new Error('Workforce request session ended');
  const raw = window.sessionStorage.getItem(key);
  if (!raw) return null;
  const saved = JSON.parse(raw);
  if (!valid(saved, scope)) throw new Error('Pending workforce request is unreadable; review the request queue before submitting');
  return { ...saved, key };
}
export async function persistExchangeRetry(scope, kind, body) {
  const revision = sessionRevision;
  const saved = { kind, body };
  if (!valid(saved, scope)) throw new Error('Invalid workforce request retry');
  const key = await storageKey(scope);
  if (revision !== sessionRevision) throw new Error('Workforce request session ended');
  const prior = window.sessionStorage.getItem(key);
  if (prior && prior !== JSON.stringify(saved)) throw new Error('Load and resolve the pending workforce request first');
  window.sessionStorage.setItem(key, JSON.stringify(saved));
  return { ...saved, key };
}
export function clearExchangeRetry(key) { window.sessionStorage.removeItem(key); }

export function clearWorkforceRetryState() {
  sessionRevision += 1;
  try {
    const storage = window.sessionStorage;
    const keys = Array.from({length:storage.length}, (_, index) => storage.key(index));
    for (const key of keys) if (key?.startsWith(STORAGE_PREFIX)) storage.removeItem(key);
    return true;
  } catch { return false; }
}
